import React, { useState } from 'react';
import LastMenu from "../ChatFlow/Lastmenu";

const Specialities = () => {
  const handleShowFrame = (id, speciality) => {
    console.log(`Selected ID: ${id}, Speciality: ${speciality}`);
    // You can add any functionality here when a button is clicked
  };

  return (
    <>
    <div>
      <a href="https://www.medicoverhospitals.in/specialties/cardiology" target="_blank" rel="noopener noreferrer">
        <button className='menu-btn' onClick={() => handleShowFrame(1, "Cardiology")}>Cardiology</button>
      </a>
      <a href="https://www.medicoverhospitals.in/specialties/gastroenterology" target="_blank" rel="noopener noreferrer">
        <button className='menu-btn' onClick={() => handleShowFrame(2, "Surgical Gastroenterology")}>Gastroenterology</button>
      </a>
      <a href="https://www.medicoverhospitals.in/specialties/neurosurgery" target="_blank" rel="noopener noreferrer">
        <button className='menu-btn' onClick={() => handleShowFrame(3, "Neuro-Surgery")}>Neuro-Surgery</button>
      </a>
      <a href="https://www.medicoverhospitals.in/specialties/orthopedics" target="_blank" rel="noopener noreferrer">
        <button className='menu-btn' onClick={() => handleShowFrame(4, "Orthopedics")}>Orthopedics</button>
      </a>
      <a href="https://www.medicoverhospitals.in/specialties/nephrology" target="_blank" rel="noopener noreferrer">
        <button className='menu-btn' onClick={() => handleShowFrame(5, "Nephrology")}>Nephrology</button>
      </a>
    </div>
     <LastMenu/>
     </>
  );
};

export default Specialities;
